import axios from '@/utils/request'
var Qs = require('qs')

export default {

	// 2021-01-30
	search(params) {
		return axios.get('/couriers-request-response?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},

	// 2022-01-14
	findByDeliverySerialNo(params) {
		return axios.get('/couriers-request-response/find-by-delivery-serial-no', params);
	},
}

